export default __webpack_public_path__ + "static/media/expandArrow.b1beddde.svg";